import type { Router } from 'vue-router'
import { formDark } from 'naive-ui'
import { getLoginInfoByToken } from '@/service/api/basic'
import { useAppStore, useAuthStore, useRouteStore, useTabStore, useTrackerStore } from '@/store'
import { local } from '@/utils'
import { validateRedirectCode } from '@/service/api/login'

const title = import.meta.env.VITE_APP_NAME

export function setupRouterGuard(router: Router) {
  const appStore = useAppStore()
  const routeStore = useRouteStore()
  const tabStore = useTabStore()
  const authStore = useAuthStore()
  const trackerStore = useTrackerStore()

  router.beforeEach(async (to, from, next) => {
    routeStore.updateRouteInfo(to, from)
    // console.log('to: ', to);
    // trackerStore.updateRouteInfo(from, to)
    // trackerStore.menu.toTitle = (to.meta.title as string) || to.fullPath
    // trackerStore.menu.toFullPath = to.fullPath
    // 如果是单例路由，则直接跳转到该路由
    if (to.meta.single) {
      return next()
    }
    if (to.query.shortCode) {
      const res = await validateRedirectCode(to.query.shortCode as string)
      if (res.code === 1000) {
        await authStore.handleLoginInfo(res.data, 'token账号登录')
      }
    }
    if (to.query.token) {
      local.set('accessToken', to.query.token as string)
      const res = await getLoginInfoByToken()
      if (res.code === 1000) {
        await authStore.handleLoginInfo(res.data, 'token账号登录')
      }
    }
    // 判断是否是外链，如果是直接打开网页并拦截跳转
    if (to.meta.href) {
      window.open(to.meta.href)
      return false
    }
    // 开始 loadingBar
    appStore.showProgress && window.$loadingBar?.start()
    // 判断有无TOKEN,登录鉴权
    const isLogin = Boolean(local.get('accessToken'))
    if (!isLogin) {
      if (to.name === 'login')
        next()

      if (to.name !== 'login') {
        const redirect = to.name === '404' ? undefined : to.fullPath
        next({ path: '/login', query: { redirect } })
      }
      return false
    }

    // 判断路由有无进行初始化
    if (!routeStore.isInitAuthRoute) {
      await routeStore.initAuthRoute()
      // 动态路由加载完回到根路由
      if (to.name === '404') {
      // 等待权限路由加载好了，回到之前的路由,否则404
        next({
          path: to.fullPath,
          replace: true,
          query: to.query,
          hash: to.hash,
        })
        return false
      }
    }

    // 判断当前页是否在login,则定位去首页
    if (to.name === 'login') {
      // next({ path: '/' })
      next({ path: to.query.redirect as string || '/' })
      return false
    }

    next()
  })
  router.beforeResolve((to) => {
    // 设置菜单高亮
    routeStore.setActiveMenu(to.meta.activeMenu ?? to.fullPath)
    // 添加tabs
    tabStore.addTab(to)
    // 设置高亮标签;
    tabStore.setCurrentTab(to.meta.tabActive ?? to.fullPath as string)
  })

  router.afterEach((to, from) => {
    // 修改网页标题
    // document.title = `${to.meta.title} - ${title}`
    document.title = `${to.meta.title}`
    // 结束 loadingBar
    appStore.showProgress && window.$loadingBar?.finish()
    // 用户登录了才记录
    // if (local.get('accessToken')) {
    //   trackerStore.menuClick(to, from)
    // }

    if (from.name === 'intellectualPropertyBrand') {
      sessionStorage.removeItem('brandStatus')
      sessionStorage.removeItem('brandExpireAct')
    }
    if (from.name === 'intellectualPropertyPatent') {
      sessionStorage.removeItem('patentCountry')
      sessionStorage.removeItem('patentStatus')
    }
    if (from.name === 'domainManage') {
      sessionStorage.removeItem('domainExpireAct')
    }
  })
}
